import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NavigationCardComponent } from '@tribeauto/ngx-mobilite-material';
import { Router } from '@angular/router';
import { UserService } from '../../user-connection/user.service';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'pvmo-home',
  imports: [NavigationCardComponent, TranslatePipe],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HomeComponent {
  private readonly router = inject(Router);
  folderNumber = 0; // will be get from an api call one day

  protected readonly userService = inject(UserService);

  navigateTo(url: string): void {
    void this.router.navigateByUrl(url);
  }
}
